<template>
  <div class="chat-feedback">
    <v-speed-dial fixed right bottom direction="top" transition="slide-y-transition">
      <template v-slot:activator>
        <v-btn v-model="fab" color="primary" dark fab @click="reset()">
          <v-icon>comment</v-icon>
          <v-icon>close</v-icon>
        </v-btn>
      </template>

      <v-card
        class="form-group mb-3 p-rel"
        @click.native.stop="fab = !fab"
        elevation-10
        :dark="submit"
        :color="submit ? 'primary' : 'white'"
      >
        <transition name="fade">
          <div v-if="!submit" class="p-rel t-0 w-100">
            <v-responsive contain height="auto" class="primary p-rel t-0" dark>
              <v-card-title primary-title class="px-0">
                <h4 class="white--text">So, what do you think?</h4>
              </v-card-title>
            </v-responsive>
            <v-form
              v-model="valid"
              ref="form"
              lazy-validation
              class="pt-2"
              @click.native.stop="fab = !fab"
            >
              <v-card-title primary-title class="pt-0 pb-0">
                <v-text-field label="Name" v-model="form.name" required></v-text-field>
                <v-text-field label="E-mail" v-model="form.email" :rules="emailRules" required></v-text-field>
                <v-text-field label="Message" v-model="form.message" required></v-text-field>
                <!-- Honey Pot for Spam -->
                <v-text-field class="ohnohoney" label="Phone Number" v-model="form.phoneNumber"></v-text-field>
                <v-checkbox label="Do you want us to follow up?" v-model="form.followUp" required></v-checkbox>
              </v-card-title>
              <v-card-actions>
                <v-btn
                  @click="validate"
                  :disabled="!valid"
                  dark
                  block
                  color="primary mb-0 elevation-0"
                >
                  <strong>Let's chat!</strong>
                </v-btn>
              </v-card-actions>
            </v-form>
          </div>

          <v-card-title v-if="submit" primary-title class="text-xs-center t-0 p-rel w-100">
            <h3 class="mb-3">
              Your message has been received!
              <br />
            </h3>
            <v-btn fab large color="white" class="elevation-0 mb-5 mx-auto" justify-center>
              <v-icon color="primary">mail</v-icon>
            </v-btn>
            <p class="mb-5">We'll be sure to review your message over the next few days!</p>
          </v-card-title>
        </transition>
      </v-card>
    </v-speed-dial>
  </div>
</template>

<style lang="scss">
.chat-feedback {
  .form-group {
    position: relative;
    right: 122px;
    width: 300px;
    background: white;
    transition: all 0.5s ease;
  }
}

.ohnohoney {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  z-index: -1;
}
</style>

<script>
import { db, CurrentTime } from '@/db.js'
import startCase from 'lodash.startcase'

export default {
  name: 'chatFeedback',
  data () {
    return {
      form: {
        name: '',
        email: '',
        message: '',
        followUp: false,
        phoneNumber: null
      },
      submit: false,
      fab: false,
      valid: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          'E-mail must be valid'
      ]
    }
  },
  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.sendForm()
      }
    },
    reset () {
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
      this.submit = false
    },
    getCurrentPage () {
      let fullPath = this.$router.currentRoute.fullPath
      let spacer = ' Zyl '

      if (fullPath === '/') {
        return 'Home'
      } else if (fullPath) {
        return startCase(
          fullPath
            .substring(1)
            .split('/')
            .join(spacer)
        ).replace(spacer, ' : ')
      }
    },
    sendForm () {
      let vm = this
      let formPayload = { ...vm.form }

      formPayload.createdAt = CurrentTime
      formPayload.url = vm.getCurrentPage()

      // Honey Pot Check
      if (formPayload.phoneNumber) {
        throw new Error('Invalid Form Input')
      }

      db.collection('chatFeedback')
        .doc()
        .set(formPayload)
        .then(response => {
          vm.submit = true
        })
        .catch(error => {
          vm.triggerSnackbar('Something went wrong, try again later.')
          throw new Error(error)
        })
    },
    triggerSnackbar (text) {
      this.$store.dispatch('setsnackbarOptions', {
        text: text,
        btnText: 'Close',
        color: 'error'
      })
    }
  }
}
</script>
